import { Injectable } from '@angular/core';
import { Selector, State } from '@ngxs/store';
import { IDynamicActionsBrickConfiguration } from 'src/app/components/bricks/dynamic-actions-brick/dynamic-actions-brick-configuration/dynamic-actions-brick-configuration';
import { IDynamicActionsBrickDropdownConfiguration } from 'src/app/components/bricks/dynamic-actions-brick/dynamic-actions-brick-configuration/dynamic-actions-brick-dropdown-configuration';
import { DynamicActionsBehaviorStateSelectors } from './dynamic-actions-behavior.selectors';
import { DynamicActionsBehaviorState, IDynamicActionsBehaviorStateModel } from './dynamic-actions-behavior.state';

@State<IDynamicActionsBehaviorStateModel>({
   name: 'dynamicActionsBehavior',
   defaults: {},
})
@Injectable()
export class DynamicActionsBehaviorStateDropdownSelectors extends DynamicActionsBehaviorStateSelectors {
   constructor() {
      super();
   }

   @Selector([DynamicActionsBehaviorState.getSpecificBehaviorStateOrDefault])
   public static getDynamicActionsBrickDropdownConfiguration(
      getSpecificBehaviorStateOrDefault: (brickInstanceId: string) => IDynamicActionsBrickConfiguration
   ) {
      return (brickInstanceId: string) => {
         return getSpecificBehaviorStateOrDefault(brickInstanceId) as IDynamicActionsBrickDropdownConfiguration;
      };
   }

   @Selector([DynamicActionsBehaviorStateDropdownSelectors.getDynamicActionsBrickDropdownConfiguration])
   public static getSpecificItemsFn(getDynamicActionsBrickDropdownConfiguration: (brickInstanceId: string) => IDynamicActionsBrickDropdownConfiguration) {
      return (brickInstanceId: string) => {
         return getDynamicActionsBrickDropdownConfiguration(brickInstanceId)?.items ?? [];
      };
   }
}
